import React, { FC } from 'react'

import { IconReturnProductProps } from './IconReturnProduct.types'
import * as Styled from './styles/IconReturnProduct.style'

import { nonThemeableRules } from '../../ruleSet'

const IconReturnProduct: FC<IconReturnProductProps> = ({
  size = nonThemeableRules.defaultSize as number as IconReturnProductProps['size'],
  isResponsive = false,
}: IconReturnProductProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.828 31h5.842M19 15h-5.533A8.47 8.47 0 0 0 5 23.465V28a3 3 0 0 0 3 3h3.172'
          stroke='#0D0D0D'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19 15v16h14.172a3 3 0 0 1 5.656 0A4.322 4.322 0 0 0 43 26.675V11H23a4 4 0 0 0-4 4Z'
          stroke='#0D0D0D'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M33 32a3 3 0 1 0 5.999 0A3 3 0 0 0 33 32Z' stroke='#E60000' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='m24.975 17.993 2.987 2.987M26 26.012h7A4.007 4.007 0 0 0 33 18h-7.172m2.142-3-2.995 2.992'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M11.125 32.16a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z' stroke='#E60000' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconReturnProduct
